import React, { useState } from "react";

/**
 * FAQ Section - Accordion-style FAQ component
 */
export default function FAQSection({ 
    title,
    description,
    faqs = [],
    backgroundColor = "offwhite"
}) {
    const [openIndex, setOpenIndex] = useState(null);
    const bgColorClass = backgroundColor === "sage" ? "bg-sage" : backgroundColor === "white" ? "bg-white" : "bg-offwhite";

    return (
        <section className={`pt-8 md: py-16 lg:py-24 ${bgColorClass}`}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col items-center text-center text-charcoal mb-8">
                    <h1 className="text-3xl md:text-4xl font-semibold font-heading">
                        {title}
                    </h1>
                    {description && (
                        <p className="text-sm sm:text-base text-charcoal mt-4 max-w-2xl font-body">
                            {description}
                        </p>
                    )}
                </div>
                
                <div className="max-w-5xl mx-auto w-full flex flex-col gap-4 items-start text-left">
                    <style jsx>{`
                        .faq-content p {
                            margin-bottom: 0.75rem;
                        }
                        .faq-content p:last-child {
                            margin-bottom: 0;
                        }
                        .faq-content ul {
                            margin-top: 0.5rem;
                            margin-bottom: 0.75rem;
                        }
                        .faq-content li {
                            margin-bottom: 0.65rem;
                            padding-left: 0.25rem;
                            line-height: 1.6;
                        }
                        .faq-content li:last-child {
                            margin-bottom: 0;
                        }
                        .faq-content strong {
                            display: inline-block;
                            margin-bottom: 0.25rem;
                        }
                    `}</style>
                    {faqs.map((faq, index) => (
                        <div key={index} className="flex flex-col items-start w-full border border-white rounded-lg overflow-hidden bg-sage">
                            <div 
                                className={`flex items-center justify-between w-full cursor-pointer p-3 sm:p-4 hover:bg-opacity-90 transition-all ${
                                    openIndex === index ? "" : ""
                                }`}
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            >
                                <h2 className="text-sm sm:text-base font-semibold font-body pr-4">
                                    {faq.question}
                                </h2>
                                <svg 
                                    width="18" 
                                    height="18" 
                                    viewBox="0 0 18 18" 
                                    fill="none" 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    className={`${openIndex === index ? "rotate-180" : ""} transition-all duration-500 ease-in-out flex-shrink-0`}
                                >
                                    <path 
                                        d="m4.5 7.2 3.793 3.793a1 1 0 0 0 1.414 0L13.5 7.2" 
                                        stroke="#1D293D" 
                                        strokeWidth="1.5" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round" 
                                    />
                                </svg>
                            </div>
                            <div 
                                className={`faq-content text-sm sm:text-base text-charcoal px-4 sm:px-6 transition-all duration-500 ease-in-out overflow-hidden font-body border-t leading-relaxed ${
                                    openIndex === index 
                                        ? "opacity-100 max-h-[2000px] translate-y-0 pt-6 sm:pt-7 pb-6 border-white" 
                                        : "opacity-0 max-h-0 -translate-y-2 border-transparent"
                                }`}
                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
